import { render, staticRenderFns } from "./NtField.vue?vue&type=template&id=4a48628b&scoped=true"
import script from "./NtField.vue?vue&type=script&lang=js"
export * from "./NtField.vue?vue&type=script&lang=js"
import style0 from "./NtField.vue?vue&type=style&index=0&id=4a48628b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48628b",
  null
  
)

export default component.exports